import React from 'react';
import AppConfig from '../../config/app-config';
import useDocumentTitle from '../../modules/lower-ui-kit/hooks/useDocumentTitle/useDocumentTitle';
import LoginSceneView from './login-scene-view';
import LoginSceneMaintenanceView from './login-scene-maintenance-view';

function LoginSceneProvider() {
  // title
  const titlePrefix = 'DocUpload | ';

  const { pageTitle } = AppConfig.Copy.LoginPage;

  const [copy, _] = React.useState(AppConfig.Copy.LoginPage);
  const [pageTitleState, __] = React.useState(`${titlePrefix}${pageTitle}`);

  useDocumentTitle(pageTitleState);

  if (AppConfig.MaintenanceMode === 'true') {
    return (
      <LoginSceneMaintenanceView
        {...copy}
      />
    );
  }

  return (
    <LoginSceneView
      {...copy}
    />
  );
}

export default LoginSceneProvider;
